import { ApiUtility } from "../Utilities/ApiUtility.axios";

export enum DashboardStateType {
    IncommingCalls = 1,
    OutgoingCalls = 2,
    Emails = 3,
    StorageUses = 4,
    InvoicesAmount = 5,
    ReceiptAmount = 6,
    StriptAmount = 7,
    GoCardLessAmount = 8,
}

class DashboardService {
    route = `/API/Dashboard`;

    getPracticeStatsFinancialDetails = (fromDate: string, toDate: string) => ApiUtility.get(`${this.route}/PracticeStatsFinancialDetails`, { fromDate, toDate })

    getSubmissionDetails = (practiceId: number, fromDate: string, toDate: string) => ApiUtility.get(`${this.route}/SubmissionDetails`, { practiceId, fromDate, toDate });

    getInvoiceDetails = (practiceId: number, fromDate: string, toDate: string) => ApiUtility.get(`${this.route}/InvoiceDetails`, { practiceId, fromDate, toDate })

    getPracticeUserDetails = (fromDate: string, toDate: string) => ApiUtility.get(`${this.route}/PracticeUserDetails`, { fromDate, toDate })

    getUpdateDetails = (fromDate: string, toDate: string, start: number, length: number, sortCol: string, sortDir: string) =>
        ApiUtility.get(`${this.route}/UpdateDetails`, { fromDate, toDate, start, length, sortDir, sortCol });

    getModelStateDetails = (modelType: DashboardStateType, start: number, length: number, fromDate: string, toDate: string, sortDir: string, sortCol: string, practiceId: number[]) =>
        ApiUtility.get(`${this.route}/ModelStatsDetails/${modelType}`, { start, length, fromDate, toDate, sortDir, sortCol, practiceId })
};

export default new DashboardService();